import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Header from '../components/Header';
import Binder from '../components/Binder';
import './PromoListingsPage.css';
import { LoadingContext } from '../App';

const PromoListingsPage = () => {
    const [listings, setListings] = useState([]);
    const [error, setError] = useState(null);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const { setLoading } = useContext(LoadingContext);

    useEffect(() => {
        const fetchListings = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${apiBaseUrl}/listings?isPromo=1&count=500`);
                if (!response.ok) {
                    throw new Error('Failed to fetch listings');
                }
                const data = await response.json();
                if (data.status === 'success' && Array.isArray(data.listings)) {
                    setListings(data.listings);
                } else {
                    setListings([]);
                }
            } catch (error) {
                console.error('Error fetching listings:', error);
                setError('Failed to load listings. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchListings();
    }, [apiBaseUrl, setLoading]);

    if (error) return <p>Error loading listings: {error}</p>;

    return (
        <Layout>
            <Header />
            <div className="promo-listings-page">
                <Binder listings={listings} />
            </div>
        </Layout>
    );
};

export default PromoListingsPage; 